/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser | { userPermissions: string[] } } | any,
) {
  const { currentUser } = initialState ?? {};

  // Create permission object from userPermissions array
  const permissions: Record<string, boolean> = {};
  const _isSuperAdmin = currentUser && 'userPermissions' in currentUser &&
                      currentUser.userPermissions?.includes('super.admin');

  if (currentUser && 'userPermissions' in currentUser && currentUser.userPermissions) {
    currentUser.userPermissions.forEach((permission: string) => {
      permissions[permission] = true;
    });
  }

  // If user is super admin, grant access to everything
  // if (isSuperAdmin) {
  //   return new Proxy(permissions, {
  //     get(target, prop) {
  //       // Always return true for super admin
  //       return true;
  //     }
  //   });
  // }

  return {
    ...permissions,
  };
}
